<template>
  <header class="header" :class="{ 'scrolled': isScrolled }">
    <div class="container">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/">
          <img src="../../assets/img/logo.png" alt="启秘科技">
        </router-link>
      </div>

      <!-- 桌面导航 -->
      <nav class="desktop-nav">
        <router-link to="/" class="nav-item" :class="{ 'active': $route.path === '/' }">首页</router-link>
        <!-- <router-link to="/Product" class="nav-item" :class="{ 'active': $route.path === '/Product' }">产品列表</router-link> -->
        <!-- <router-link to="/AboutUs" class="nav-item" :class="{ 'active': $route.path === '/AboutUs' }">关于我们</router-link> -->
      </nav>

      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-button" @click="toggleMenu">
        <span class="bar" :class="{ 'open': isMenuOpen }"></span>
        <span class="bar" :class="{ 'open': isMenuOpen }"></span>
        <span class="bar" :class="{ 'open': isMenuOpen }"></span>
        <span class="bar" :class="{ 'open': isMenuOpen }"></span>
      </div>
    </div>

    <!-- 移动端导航菜单 - 移出container -->
    <transition name="slide">
      <nav class="mobile-nav" v-show="isMenuOpen">
        <router-link to="/" class="mobile-nav-item" :class="{ 'active': $route.path === '/' }"
          @click.native="closeMenu">首页</router-link>
        <!-- <router-link to="/Product" class="mobile-nav-item" :class="{ 'active': $route.path === '/products' }"
          @click.native="closeMenu">产品列表</router-link> -->
        <!-- <router-link to="/AboutUs" class="mobile-nav-item" :class="{ 'active': $route.path === '/AboutUs' }"
          @click.native="closeMenu">关于我们</router-link> -->
      </nav>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'HeaderMenu',
  data () {
    return {
      isMenuOpen: false,
      isScrolled: false
    }
  },
  methods: {
    toggleMenu () {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu () {
      this.isMenuOpen = false
    },
    // handleScroll () {
    //   this.isScrolled = window.scrollY > 10
    // }
  },
  // mounted () {
  //   window.addEventListener('scroll', this.handleScroll)
  // },
  // beforeDestroy () {
  //   window.removeEventListener('scroll', this.handleScroll)
  // }
}
</script>

<style scoped>
/* 基础样式 */
.header {
  height: 70px;
  background-color: rgba(255, 255, 255, 0.7);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.header.scrolled {
  background-color: rgba(255, 255, 255, 0.9);
  height: 60px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
}

/* Logo 样式 */
.logo img {
  height: 40px;
  width: auto;
  transition: all 0.3s ease;
}

.header.scrolled .logo img {
  height: 35px;
}

/* 桌面导航样式 */
.desktop-nav {
  display: flex;
  gap: 30px;
}

.nav-item {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  padding: 5px 0;
  position: relative;
  transition: all 0.3s ease;
}

.nav-item:hover {
  color: #000;
}

.nav-item.active {
  color: #000;
  font-weight: 600;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #333;
}

/* 移动端菜单按钮 */
.mobile-menu-button {
  display: none;
  width: 30px;
  height: 25px;
  position: relative;
  cursor: pointer;
  z-index: 1001;
}

.bar {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: white;
  border-radius: 3px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: all 0.3s ease;
}

.bar:nth-child(1) {
  top: 0;
}

.bar:nth-child(2),
.bar:nth-child(3) {
  top: 10px;
}

.bar:nth-child(4) {
  top: 20px;
}

.bar.open:nth-child(1),
.bar.open:nth-child(4) {
  top: 10px;
  width: 0%;
  left: 50%;
}

.bar.open:nth-child(2) {
  transform: rotate(45deg);
}

.bar.open:nth-child(3) {
  transform: rotate(-45deg);
}

.mobile-nav {
  display: none;
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  flex-direction: column;
}

.header.scrolled .mobile-nav {
  top: 60px;
}

.mobile-nav-item {
  color: #333;
  text-decoration: none;
  padding: 15px 30px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-nav-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.mobile-nav-item.active {
  color: #000;
  font-weight: 600;
  background-color: rgba(0, 0, 0, 0.05);
  border-left: 3px solid #333;
}

/* 过渡动画 */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    height: 60px;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .header.scrolled {
    height: 50px;
  }

  .logo img {
    height: 35px;
  }

  .desktop-nav {
    display: none;
  }

  .mobile-menu-button {
    display: block;
  }

  .mobile-nav {
    display: flex;
    top: 60px;
  }

  .header.scrolled .mobile-nav {
    top: 50px;
  }

  .bar {
    height: 2px;
  }

  .bar:nth-child(2),
  .bar:nth-child(3) {
    top: 9px;
  }
}
</style>